import React from 'react';
import { Box, Typography, Button, useTheme, TextField, InputAdornment } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import HomeIcon from '@mui/icons-material/Home';
import { keyframes } from '@emotion/react';



const NotFoundPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoHome = () => {
    navigate('/');
  };
  const handleContact = () => {
    navigate('/contact'); 
  };
  const [searchQuery, setSearchQuery] = React.useState('');
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        px: 2,
        textAlign: 'center',
        background: theme.palette.mode === 'dark'
          ? 'linear-gradient(135deg, #0d0d1a 0%, #1a1a2e 100%)'
          : 'linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%)',
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '5rem', sm: '6rem', md: '8rem' },
          fontWeight: 900,
          color: theme.palette.primary.main,
          mb: { xs: 1, sm: 2 },
          lineHeight: 1,
          textShadow: theme.palette.mode === 'dark' 
            ? '2px 2px 4px rgba(0,0,0,0.5)' 
            : '3px 3px 6px rgba(0,0,0,0.1)',
        }}
      >
        404
      </Typography>

      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          mb: { xs: 1, sm: 2 },
          color: theme.palette.text.primary,
        }}
      >
        {t('page_not_found') || 'الصفحة غير موجودة'}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          maxWidth: 600,
          mb: 4,
          color: theme.palette.text.secondary,
          fontSize: { xs: '1rem', sm: '1.1rem' },
        }}
      >
        {t('page_not_found_message') || 'عذراً، الصفحة التي تبحث عنها قد تم نقلها أو حذفها.'}
      </Typography>


      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button
          variant="contained"
          startIcon={<HomeIcon sx={{mx:1}}/>}
          onClick={handleGoHome}
          sx={{
            px: 3,
            py: 1.5,
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(0, 174, 233, 0.3)',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 16px rgba(0, 174, 233, 0.4)',
            },
          }}
        >
          {t('back_to_home') || 'العودة إلى الرئيسية'}
        </Button>

    
      </Box>
    </Box>
  );
};

export default NotFoundPage;
